/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = {
  api: vp.Api;
};
type HookTuple = [
  response: vp.ApiResponse,
  SendOnboardingEmail: (params: vp.SendOnboardingEmailRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostSendOnboardingEmail: ApiHook = ({ api }) => {
  const [shouldSendOnboardingEmail, setShouldSendOnboardingEmail] = useState(false);
  const source = axios.CancelToken.source();
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  const [params, setParams] = useState<vp.SendOnboardingEmailRequest>({
    Name: '',
    Email: '',
    Link: '',
    VopayAccountID: '',
  });
  const [response, setResponse] = useState<vp.ApiResponse>({
    Success: false,
    ErrorMessage: '',
  });

  useEffect(() => {
    if (!shouldSendOnboardingEmail) return () => {};

    const SendOnboardingEmail = async () => {
      setDataFetchingInfo(true, 'Sending Onboarding Email', 'fullScreen');
      const res = await api.postSendOnboardingEmail(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldSendOnboardingEmail) void SendOnboardingEmail();
    setShouldSendOnboardingEmail(false);
    return () => {
      source.cancel();
    };
  }, [shouldSendOnboardingEmail]);

  return [
    response,
    (_params: vp.SendOnboardingEmailRequest) => {
      setParams(_params);
      setShouldSendOnboardingEmail(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
      });
      setShouldSendOnboardingEmail(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostSendOnboardingEmail);
